import 'classlist-polyfill';

import wrapper from 'wrapper';

import Pocket from './components/pocket/pocket';

function main() {
    const root = wrapper.select('#vjeastasia-540');
    const pocket = new Pocket(root.querySelector('.pocket'));
    pocket.connect();
    root.classList.remove('no-js');
    wrapper.markPageAsLoaded();
}

main();
